class FFFaq extends HTMLElement {
  connectedCallback() {
    this.details = Array.from(this.querySelectorAll('.ff-faq__details'));
    if (this.details.length === 0) return;

    const singleOpen = this.dataset.singleOpen !== 'false';

    if (!singleOpen) return;

    this.details.forEach((detail) => {
      detail.addEventListener('toggle', () => {
        if (!detail.open) return;

        this.details.forEach((other) => {
          if (other !== detail && other.open) other.open = false;
        });
      });
    });
  }
}

customElements.define('ff-faq', FFFaq);
